export default "__VITE_ASSET__BpkqKaVe__"